import cn from "classnames"

import style from "./styles.module.scss"

import { QUALITY_LEVEL } from "modules/PsychologistAccount/SettingsTab/components/PsyIndexQuality/common/constants"
import { useGetPsyIndexQualityData } from "modules/PsychologistAccount/SettingsTab/components/PsyIndexQuality/common/api"
import { Img } from "ui-kit/components-branded/index"

export function HeaderQualityLabel() {
    const { isFetching, data, isError } = useGetPsyIndexQualityData()

    if (isFetching || isError || !data?.value) return null

    let dropoutCoefficient = data?.value || 0

    if (dropoutCoefficient <= 1) dropoutCoefficient = Math.round(dropoutCoefficient * 100)

    return dropoutCoefficient ? (
        <div className={style.container} data-testid="psy-header-quality-label">
            {dropoutCoefficient > QUALITY_LEVEL.HIGH && (
                <Img src="thumbs-up-emoji.png" className={style.emoji} />
            )}{" "}
            <span className={style.title}>Качество&nbsp;</span>
            <span
                className={cn(style.quantity, {
                    [style.quantityRed]: Number(dropoutCoefficient) <= QUALITY_LEVEL.LOW,
                })}
            >
                {dropoutCoefficient}
            </span>
        </div>
    ) : (
        <></>
    )
}
